import { render, staticRenderFns } from "./MyProfileNotificationPreferences.vue?vue&type=template&id=29e1b75f&scoped=true"
import script from "./MyProfileNotificationPreferences.vue?vue&type=script&lang=js"
export * from "./MyProfileNotificationPreferences.vue?vue&type=script&lang=js"
import style0 from "./MyProfileNotificationPreferences.vue?vue&type=style&index=0&id=29e1b75f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e1b75f",
  null
  
)

export default component.exports